import debounce from '@mui/utils/debounce';
import { useCallback, useEffect, useState } from 'react';
export const useDynamicElementHeight = ()=>{
    const [elementHeight, setElementHeight] = useState(null);
    const [elementNode, setElementNode] = useState(null);
    const elementRef = useCallback((node)=>{
        if (node !== null) {
            setElementNode(node);
        }
    }, []);
    useEffect(()=>{
        const appBarResizeObserver = new ResizeObserver((entries)=>{
            const newHeight = Math.ceil(entries[0].contentRect.height);
            if (elementHeight !== newHeight) {
                debounce(()=>{
                    setElementHeight(newHeight);
                }, 30)();
            }
        });
        if (elementNode) {
            appBarResizeObserver.observe(elementNode);
        }
        return ()=>{
            appBarResizeObserver.disconnect();
        };
    }, [
        elementHeight,
        elementNode
    ]);
    return {
        elementHeight,
        elementRef
    };
};
